import React, { useEffect, useState } from 'react';
import { Box, Container, LinearProgress } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuth } from '../features/auth/slices/authSlice';
import { AppDispatch, RootState } from '../store';
import NotificationSnackbar, { NotificationType } from 'components/common/NotificationSnackBar';
import AppHeader from 'components/common/AppHeader';

const PublisherLayout: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading } = useSelector((state: RootState) => state.auth);
  
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    type: 'info' as NotificationType,
  });

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const result = await dispatch(checkAuth());
        if (result.payload === null) {
          setNotification({
            ...notification,
            open: true,
            message: 'The Location Station server may be down. Contact support@locationstation.net for Support.'
          });  
        }
      } catch (error) {
      }
    };
    
    verifyAuth();
  }, [dispatch, notification]);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, isLoading, navigate, user]);

  const closeNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      <AppHeader />
      <Container maxWidth="xl" sx={{ flexGrow: 1, py: 3 }}>
        <Outlet />
      </Container>
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        type={notification.type}
        onClose={closeNotification}
      />
    </Box>
  );
};

export default PublisherLayout;